import { URITypeMap } from './enums/uri_type';
import { parseURI } from './uri';
export const isAdURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.AD;
};
export const isAlbumURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ALBUM;
};
export const isApplicationURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.APPLICATION;
};
export const isArtistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ARTIST;
};
export const isArtistToplistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ARTIST_TOPLIST;
};
export const isArtistConcertsURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ARTIST_CONCERTS;
};
export const isAudioURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.AUDIO;
};
export const isAudioFileURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.AUDIO_FILE;
};
export const isCachedFilesURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CACHED_FILES;
};
export const isCanvasURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CANVAS;
};
export const isChatMessageURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CHAT_MESSAGE;
};
export const isCollectionURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION;
};
export const isCommentURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COMMENT;
};
export const isConceptURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONCEPT;
};
export const isContributorURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONTRIBUTOR;
};
export const isCulturalMomentURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CULTURAL_MOMENT;
};
export const isGenreURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.GENRE;
};
export const isQueueURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.QUEUE;
};
export const isCollectionAlbumURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_ALBUM;
};
export const isCollectionArtistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_ARTIST;
};
export const isCollectionMissingAlbumURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_MISSING_ALBUM;
};
export const isCollectionTrackListURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COLLECTION_TRACK_LIST;
};
export const isConcertURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONCERT;
};
export const isContextGroupURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.CONTEXT_GROUP;
};
export const isDailyMixURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.DAILY_MIX;
};
export const isEmptyURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.EMPTY;
};
export const isEpisodeURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.EPISODE;
};
export const isFacebookURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FACEBOOK;
};
export const isFestivalURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FESTIVAL;
};
export const isFolderURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FOLDER;
};
export const isFollowersURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FOLLOWERS;
};
export const isFollowingURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.FOLLOWING;
};
export const isImageURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.IMAGE;
};
export const isInboxURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.INBOX;
};
export const isInterruptionURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.INTERRUPTION;
};
export const isJamURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.JAM;
};
export const isLibraryURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LIBRARY;
};
export const isLiveURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LIVE;
};
export const isRoomURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ROOM;
};
export const isExpressionURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.EXPRESSION;
};
/**
 * Type guard to check if a URI is a local track URI.
 *
 * @deprecated Use `isLocalTrackURI` instead
 * @param uri - The URI to check.
 * @returns True if the URI is a `local` URI.
 */
export const isLocalURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL;
};
export const isLocalTrackURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL_TRACK;
};
export const isLocalAlbumURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL_ALBUM;
};
export const isLocalArtistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LOCAL_ARTIST;
};
export const isMerchURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MERCH;
};
export const isMerchHubURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MERCHHUB;
};
export const isMosaicURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MOSAIC;
};
export const isPlaylistV1URI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PLAYLIST;
};
/**
 * @deprecated Use `isPlaylistV1URI` instead.
 */
export const isPlaylistURI = isPlaylistV1URI;
export const isPlaylistV2URI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PLAYLIST_V2;
};
export const isPlaylistV1OrV2URI = (uri) => {
    // Checking for strings helps Typescript to understand which overload to use
    // from the TypeGuard definition
    if (typeof uri === 'string') {
        return isPlaylistV1URI(uri) || isPlaylistV2URI(uri);
    }
    return isPlaylistV1URI(uri) || isPlaylistV2URI(uri);
};
export const isPrereleaseURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PRERELEASE;
};
export const isProfileURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PROFILE;
};
export const isPublishedRootlistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PUBLISHED_ROOTLIST;
};
export const isRadioURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.RADIO;
};
export const isRootlistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.ROOTLIST;
};
export const isSearchURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SEARCH;
};
export const isShowURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SHOW;
};
export const isSocialSessionURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SOCIAL_SESSION;
};
export const isSpecialURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SPECIAL;
};
export const isStarredURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.STARRED;
};
export const isStationURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.STATION;
};
export const isSupplementaryMaterialURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SUPPLEMENTARY_MATERIAL;
};
export const isTemporaryPlaylistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TEMP_PLAYLIST;
};
export const isToplistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TOPLIST;
};
export const isTourURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TOUR;
};
export const isTrackURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TRACK;
};
export const isTracksetURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.TRACKSET;
};
export const isUserToplistURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.USER_TOPLIST;
};
export const isUserTopTracksURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.USER_TOP_TRACKS;
};
export const isUnknownURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri, { parseUnknown: true })) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.UNKNOWN;
};
export const isVenueURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.VENUE;
};
export const isVideoURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.VIDEO;
};
export const isMediaURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.MEDIA;
};
export const isPollURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.POLL;
};
export const isQuestionURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.QUESTION;
};
export const isResponseURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.RESPONSE;
};
export const isCourseURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.COURSE;
};
export const isLessonURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.LESSON;
};
export const isPromoterURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PROMOTER;
};
export const isPromotionURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PROMOTION;
};
export const isSiteURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.SITE;
};
export const isPresentsURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.PRESENTS;
};
export const isS4AThirdPartyURI = (uri) => {
    var _a;
    return ((_a = parseURI(uri)) === null || _a === void 0 ? void 0 : _a.type) === URITypeMap.S4A_THIRD_PARTY;
};
//# sourceMappingURL=type_guards.js.map